import React from 'react'
import { Link } from 'react-router-dom'

function DownloadApp() {
    return (
        <>
            <div className="innerslide py-3 bg-light border-bottom">
                <ul className="breadcrumb container mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">  Download Mobile App</li>
                </ul>
            </div>
            <div class="innersec container py-5">
                <h1>Download Mobile App</h1>

                <div class="card shadow border-0">
                    <div class="card-body p-4">

                        <h4 class="fw-semibold mb-3">CampusCare 10x Mobile App for Parents</h4>

                        <p class="mb-3">
                            CampusCare 10x mobile app for parents is a centralized tool for all school-parent interactions. It enables parents to stay informedabout their ward’s daily activities, including:
                        </p>

                        <ul class="list-group mb-4">
                            <li class="list-group-item">Assignments and homework</li>
                            <li class="list-group-item">Circulars and announcements</li>
                            <li class="list-group-item">Attendance records</li>
                            <li class="list-group-item">Online fee payment</li>
                            <li class="list-group-item">Report card access</li>
                        </ul>

                        <h5 class="fw-semibold mb-3">Steps to Log In:</h5>

                        <ol class="list-group list-group-numbered mb-4">
                            <li class="list-group-item">
                                Download <strong>CampusCare 10x Mobile App</strong> from
                                <a href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui" target="_blank"> Google Play Store</a>
                                or <a href="https://apps.apple.com/in/app/campuscare/id1034721587" target="_blank">Apple App Store</a>.
                            </li>
                            <li class="list-group-item">
                                Open the app, enter the <strong>School Code:</strong>
                                <code><b>FAJSBL</b></code> and tap <strong>Proceed</strong>.
                            </li>
                            <li class="list-group-item">
                                Enter your <strong>registered mobile number</strong> and verify using the OTP.
                            </li>
                            <li class="list-group-item">
                                Log in with your <strong>Username (mobile number)</strong> and <strong>Password</strong>.
                            </li>
                        </ol>

                        <div class="text-center mt-4">
                            <a href="https://play.google.com/store/apps/details?id=com.campuscare.entab.ui" class="btn btn-success me-2" target="_blank">
                                <i class="bi bi-android2"></i> Download for Android
                            </a>
                            <a href="https://apps.apple.com/in/app/campuscare/id1034721587" class="btn btn-dark" target="_blank">
                                <i class="bi bi-apple"></i> Download for iOS
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default DownloadApp